import Super from './consent-document-form';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsStoredDocumentForm extends Super {}
